import {Component, ViewChild}      from '@angular/core';
import {ApDynformsComponent}       from '../../ap-dynforms/ap-dynforms.component';
import {ApDynformsConfigFieldset}  from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ApDynformsConfigLabelIcon} from '../../ap-dynforms/config/ap-dynforms-config-label-icon';
import {RouterStore}               from '../../stores/router/router.store';

/**
 * Component for the contact
 */
@Component({
  selector: 'ap-contact',
  template: `
    <ap-dynforms [fieldsets]="formConfig" [caption]="caption">
      <div dynforms.after>
        <button kendoButton [primary]="true" (click)="onBackToLoginClick()">
          {{'Admin_Pages_Back_To_Registration' | translate}}
        </button>
      </div>
    </ap-dynforms>
  `
})

export class ApContactComponent {
  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  public formConfig: ApDynformsConfigFieldset[];
  public caption: string;

  constructor(private routerStore: RouterStore) {
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'contact_fieldset',
        columns: 1,
        legend: 'Tip_ContactText',
        label: '',
        config: [
          new ApDynformsConfigLabelIcon({
            key: 'en',
            src: 'assets/img/flags/gb.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+49 34324 524 555',
            label2: 'Global__Email',
            text2: 'service@agricon.de'
          }),
           new ApDynformsConfigLabelIcon({
            key: 'de',
            src: 'assets/img/flags/de.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+49 34324 524 555',
            label2: 'Global__Email',
            text2: 'service@agricon.de'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'lv',
            src: 'assets/img/flags/lv.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+371 2576 8830',
            label2: 'Global__Email',
            text2: 'info@agricon-baltic.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'lt',
            src: 'assets/img/flags/lt.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+370 6124 0119',
            label2: 'Global__Email',
            text2: 'info@agricon-baltic.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'ee',
            src: 'assets/img/flags/ee.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+372 525 3431',
            label2: 'Global__Email',
            text2: 'info@agricon-baltic.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'hu',
            src: 'assets/img/flags/hu.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+36 30 696 53 66',
            label2: 'Global__Email',
            text2: 'info@agricon-hungary.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'ro',
            src: 'assets/img/flags/ro.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+36 30 696 53 66',
            label2: 'Global__Email',
            text2: 'info@agricon-hungary.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'pl',
            src: 'assets/img/flags/pl.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+48 730 006 183',
            label2: 'Global__Email',
            text2: 'info@agricon-polska.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'sk',
            src: 'assets/img/flags/sk.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+421 907 078 773',
            label2: 'Global__Email',
            text2: 'info@agricon-slovakia.com'
          }),
          new ApDynformsConfigLabelIcon({
            key: 'cz',
            src: 'assets/img/flags/cz.png',
            label1: 'Docu_Ini__PhoneShort',
            text1: '+421 907 078 773',
            label2: 'Global__Email',
            text2: 'info@agricon-slovakia.com'
          })
        ]
      })
    ];
  }

  public onBackToLoginClick(): void {
    this.routerStore.navigateToLogin().then(() => {
    });
  }
}
